export interface TelemetryDetailsModel {
  controller_uuid: string;
  device_id: string;

  xAxisDateFormat?: string;
  maxValue?: number;
  curveStyle?: string;
  telemetry: TelemetryModel[];
}

export interface TelemetryParameterListModel {
  result: TelemetryModel[];
}

export class TelemetryModel {
  _time: string = '';
  temperature?: number;
  orp?: number;
  salt?: number;
  rpm?: number;
  ph?: number;
  outlet_temperature?: number;
  compressor_current?: number;
  compressor_freequency?: number;
  input_power?: number;
  value?: number;
  status?: number;
  instantaneous_flow?: number;
  positive_cumulative_flow?: number;
  reverse_cumulative_flow?: number;
  water_temperature?: number;
  cell_status?: number;
  cell_current?: number;
  production_percentage?: number;
  pool_cover_status?: number;
  voltage?: number;
  backwash?: number;
  _field?: string;
  cover_mode_status?: number;
  pool_health?: string;
}
export class TelemetryDataHelper {
  static setValues(value: any, includeMinusOne: boolean): TelemetryModel[] {
    const list: TelemetryModel[] = [];
    const keys = Object.keys(value);
    for (const key of keys) {
      if (key == '_time' || key == '_field' || key == 'recorded_time') {
        continue;
      }
      const data = value[key];
      if ((data || data == 0) && (includeMinusOne || data != -1)) {
        list.push({
          value: data,
          _time: value._time ?? value.recorded_time,
          _field: key,
        });
      }
    }
    return list;
  }

  static setValued(value: TelemetryModel): TelemetryModel | null {
    /// It will create a new object of TelemetryModel class.
    /// The field will be delete after reading the value
    /// It will help to create multiple object if the same model contains multiple type of values
    const data = { ...value };
    if (value.value || value.value == 0) {
      data._field = 'value';
      delete value.value;
      return data;
    } else if (
      this.setValueOne(value, data) ||
      this.setValueTwo(value, data) ||
      this.setValueThree(value, data) ||
      this.setValueFour(value, data) ||
      this.setValueFive(value, data)
    ) {
      return data;
    }
    return null;
  }

  private static setValueOne(
    value: TelemetryModel,
    data: TelemetryModel
  ): boolean {
    if (value.temperature || value.temperature == 0) {
      data.value = value.temperature;
      data._field = 'temperature';
      delete value.temperature;
    } else if (value.orp || value.orp == 0) {
      data.value = value.orp;
      data._field = 'orp';
      delete value.orp;
    } else if (value.salt || value.salt == 0) {
      data.value = value.salt;
      data._field = 'salt';
      delete value.salt;
    } else if (value.rpm || value.rpm == 0) {
      data.value = value.rpm;
      data._field = 'rpm';
      delete value.rpm;
    } else if (value.ph || value.ph == 0) {
      data.value = value.ph;
      data._field = 'ph';
      delete value.ph;
    } else {
      return false;
    }
    return true;
  }

  private static setValueTwo(
    value: TelemetryModel,
    data: TelemetryModel
  ): boolean {
    if (value.outlet_temperature || value.outlet_temperature == 0) {
      data.value = value.outlet_temperature;
      data._field = 'outlet_temperature';
      delete value.outlet_temperature;
    } else if (value.compressor_current || value.compressor_current == 0) {
      data.value = value.compressor_current;
      data._field = 'compressor_current';
      delete value.compressor_current;
    } else if (
      value.compressor_freequency ||
      value.compressor_freequency == 0
    ) {
      data.value = value.compressor_freequency;
      data._field = 'compressor_freequency';
      delete value.compressor_freequency;
    } else if (value.input_power || value.input_power == 0) {
      data.value = value.input_power;
      data._field = 'input_power';
      delete value.input_power;
    } else {
      return false;
    }
    return true;
  }

  private static setValueThree(
    value: TelemetryModel,
    data: TelemetryModel
  ): boolean {
    if (value.status || value.status == 0) {
      data.value = value.status;
      data._field = 'status';
      delete value.status;
    } else if (value.instantaneous_flow || value.instantaneous_flow == 0) {
      data.value = value.instantaneous_flow;
      data._field = 'instantaneous_flow';
      delete value.instantaneous_flow;
    } else if (
      value.positive_cumulative_flow ||
      value.positive_cumulative_flow == 0
    ) {
      data.value = value.positive_cumulative_flow;
      data._field = 'positive_cumulative_flow';
      delete value.positive_cumulative_flow;
    } else if (
      value.reverse_cumulative_flow ||
      value.reverse_cumulative_flow == 0
    ) {
      data.value = value.reverse_cumulative_flow;
      data._field = 'reverse_cumulative_flow';
      delete value.reverse_cumulative_flow;
    } else {
      return false;
    }
    return true;
  }

  private static setValueFour(
    value: TelemetryModel,
    data: TelemetryModel
  ): boolean {
    if (value.water_temperature || value.water_temperature == 0) {
      data.value = value.water_temperature;
      data._field = 'water_temperature';
      delete value.water_temperature;
    } else if (value.cell_status || value.cell_status == 0) {
      data.value = value.cell_status;
      data._field = 'cell_status';
      delete value.cell_status;
    } else if (value.cell_current || value.cell_current == 0) {
      data.value = value.cell_current;
      data._field = 'cell_current';
      delete value.cell_current;
    } else if (
      value.production_percentage ||
      value.production_percentage == 0
    ) {
      data.value = value.production_percentage;
      data._field = 'production_percentage';
      delete value.production_percentage;
    } else {
      return false;
    }
    return true;
  }

  private static setValueFive(
    value: TelemetryModel,
    data: TelemetryModel
  ): boolean {
    if (value.pool_cover_status || value.pool_cover_status == 0) {
      data.value = value.pool_cover_status;
      data._field = 'pool_cover_status';
      delete value.pool_cover_status;
    } else if (value.voltage || value.voltage == 0) {
      data.value = value.voltage;
      data._field = 'voltage';
      delete value.voltage;
    } else if (value.backwash || value.backwash == 0) {
      data.value = value.backwash;
      data._field = 'backwash';
      delete value.backwash;
    } else {
      return false;
    }
    return true;
  }
}
